import {
  Box,
  Typography,
  Avatar,
  Fade,
  Button,
  TextField,
  Container,
} from "@mui/material";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useMutation, useQuery, useQueryClient } from "react-query";
import * as Yup from "yup";
import { Formik, Form, useFormik } from "formik";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import Page from "../components/Page";
import FTextField from "../components/Formik/FTextField";
import FSelect from "../components/Formik/FSelect";
import FMultiSelect from "../components/Formik/FMultiSelect";
import {
  FormikStep,
  FormikStepper,
} from "../containers/Formulaire/FormikStepper";
import FDatePicker from "../components/Formik/FDatePicker";
import Navbar from "../containers/FormNavbar/FormNavBar";
import axios from "axios";
import AfriqualeosForm from "../containers/Formulaire/AfriqualeosForm";

const { REACT_APP_PATH } = process.env;

export const PostFunction = async (file) => {
  return axios.post(REACT_APP_PATH, file, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useSendMail = () => {
  return useMutation((file) => PostFunction(file), {
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

const Formulaire = () => {
  return (
    <Page
      title="Formulaire d'accompagnement à la certification"
      sx={{ overflow: " hidden" }}
    >
      <Navbar /* onOpenSidebar={() => setOpen(true)} */ />
      <Container>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignContent: "center",
              alignItems: "center",
              p: 1,
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
              flexDirection: "column",
              background: "none",
            }}
          >
            {/* <Avatar
                sx={{ width: "200px", height: "200px", marginBottom: "10px" }}
                src="./static/images/logo.png"
              ></Avatar> */}
            <img
              src="./static/images/afriqualeos.png"
              style={{ width: "200px" }}
              alt="afriqualeos"
            />
            <Typography align="center" component="h1" variant="h5">
              Formulaire d'accompagnement à la certification
            </Typography>
            <Typography mt={2} mb={4}>
              Ce formulaire consiste en la définition du besoin de l'entreprise
              en matière d'accompagnement à la certification QSE afin d'établir
              une offre adaptée à son contexte, tant en termes
              technico-financier, que délai. Les informations renseignées par
              l'entreprise dans ce formulaire seront traitées à titre
              confidentiel.
            </Typography>
            <AfriqualeosForm />
          </Box>
        </Box>
      </Container>
    </Page>
  );
};

export default Formulaire;
